import React, { useState } from 'react'
import {
  Combobox,
  ComboboxChip,
  ComboboxChips,
  ComboboxChipsInput,
  ComboboxContent,
  ComboboxItem,
  ComboboxList,
  ComboboxValue,
} from '@/components/ui/combobox'

interface StringTagsMultiSelectProps {
  value?: string[] | null
  onChange: (value: string[]) => void
  placeholder?: string
  disabled?: boolean
  fullWidth?: boolean
}

const normalizeValues = (values: string[]) => {
  const normalizedValues = values.map((value) => value.trim()).filter((value) => value.length > 0)

  return Array.from(new Set(normalizedValues))
}

export const StringTagsMultiSelect: React.FC<StringTagsMultiSelectProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  fullWidth,
}) => {
  const [inputValue, setInputValue] = useState('')
  const selectedValues = value ?? []

  const commitInputValue = () => {
    const nextValue = inputValue.trim()
    if (!nextValue) {
      return
    }

    if (!selectedValues.includes(nextValue)) {
      onChange([...selectedValues, nextValue])
    }
    setInputValue('')
  }

  return (
    <Combobox
      multiple
      autoHighlight
      disabled={disabled}
      items={selectedValues}
      value={selectedValues}
      inputValue={inputValue}
      onInputValueChange={setInputValue}
      onValueChange={(values) => onChange(normalizeValues((values ?? []) as string[]))}
    >
      <ComboboxChips className={fullWidth ? 'w-full' : undefined}>
        <ComboboxValue>
          {(values: string[]) => (
            <React.Fragment>
              {values.map((item) => (
                <ComboboxChip key={item}>{item}</ComboboxChip>
              ))}
              <ComboboxChipsInput
                disabled={disabled}
                placeholder={placeholder}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ',' || event.key === 'Tab') {
                    event.preventDefault()
                    commitInputValue()
                  }
                }}
                onBlur={commitInputValue}
              />
            </React.Fragment>
          )}
        </ComboboxValue>
      </ComboboxChips>

      <ComboboxContent>
        <ComboboxList>
          {(item: string) => (
            <ComboboxItem key={item} value={item}>
              {item}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  )
}
